import React from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import clsx from "clsx";

interface YesNoModalProps extends ModalProps {
  id?: string;
  title?: string;
  onClickYes: () => void;
  onClickNo: () => void;
  destructiveAction?: boolean;
  buttonLabels?: {
    yes: string;
    no: string;
  };
}

const YesNoModal = ({
  id,
  title,
  show,
  children,
  className,
  size,
  onClickYes,
  onClickNo,
  backdrop,
  destructiveAction = false,
  buttonLabels = {
    yes: "Yes",
    no: "No"
  }
}: YesNoModalProps) => (
  <Modal
    id={id}
    backdrop={backdrop}
    show={show}
    onHide={onClickNo}
    className={className}
    size={size}
  >
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer
      className={clsx(
        destructiveAction ? "flex-row-reverse justify-content-start" : ""
      )}
    >
      <Button
        onClick={() => onClickNo()}
        variant={
          destructiveAction ? "prompt-primary ms-10" : "prompt-secondary"
        }
        data-testid={`${id} ? "${id}-no" : ""`}
      >
        {buttonLabels.no}
      </Button>
      <Button
        onClick={() => onClickYes()}
        variant={destructiveAction ? "prompt-secondary" : "prompt-primary"}
        data-testid={id ? `${id}-yes` : ""}
      >
        {buttonLabels.yes}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default YesNoModal;
